

import styled from "styled-components";

const StyleWrapper = styled.div`


.common_input {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);


  .p-float-label {
    display: flex;
    align-items: center;
    padding: .9rem;
    height: 70px;


    input {
      width: 100%;
      border: none;


      &.p-inputtext:enabled:focus {
        border-color: unset;
        box-shadow: unset;
      }

      &:focus~label,
      &.p-filled~label {
        top: 0.8rem;
        left: 1rem;
        font-size: 0.8rem;
      }
    }

    label {
      left: 1rem;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 16px;
      color: #455560 !important;
    }
  }
}

.common_input_noleftIcon {
  .p-float-label {
    input {

      &:focus~label,
      &.p-filled~label {
        left: 1rem;
      }
    }

    label {
      left: 1rem;
    }
  }
}

.myfamily_main_wrapper_ar {
  .common_input {
    .p-float-label {
      input {

        &:focus~label,
        &.p-filled~label {
          right: 1rem;
        }
      }

      label {
        right: 1rem;
      }
    }
  }

  .common_input_noleftIcon {
    .p-float-label {
      input {

        &:focus~label,
        &.p-filled~label {
          right: 1rem;
        }
      }

      label {
        right: 1rem;
      }
    }
  }
}

.p-inputgroup-addon {
  border: transparent;
}

.p-invalid {
  border: 1px solid #e24c4c;
  border-radius: 8px;
}

.ar{
    .p-float-label {
      input {

        &:focus~label,
        &.p-filled~label {
          right: 1rem;
        }
      }

      label {
        right: 1rem;
      }
    }
}
`

export default StyleWrapper;
